/*=========================================================================================
  File Name: module-confirm-business-state.js
  Description: Confirm Business Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
    ConfirmListBusiness: [],
    Total: 0,
    IsLoading: false,
};